import { clsx } from "clsx";
import { twMerge, type ClassNameValue } from "tailwind-merge";

function cn(...inputs: ClassNameValue[]): string {
  return twMerge(clsx(inputs));
}

export { cn };
